import { http_client } from "../plugins/http_client";


const getData = async(data) => await http_client(process.env.VUE_APP_API_ID_URL+`${data}`,"get");

export default{
    getData
}